import { useMemo } from 'react';

import { useLenderId } from '@shared/hooks/useLenderId';
import { Wrapper } from '@styles/CommonStyles';
import { LenderControlsHeader } from '../shared/LenderControlsHeader';
import { LenderUtilityTabs } from './tabs/LenderUtilityTabs';

export const CREATE_LENDER = 'create';

export const LenderUtility = () => {
  const lenderId = useLenderId();

  return useMemo(
    () => (
      <Wrapper>
        <LenderControlsHeader showAddButton title="Lender Utility" />

        {lenderId && <LenderUtilityTabs key={lenderId} lenderId={lenderId} />}
      </Wrapper>
    ),
    [lenderId],
  );
};
